import { OpenInNewWindowIcon } from '@radix-ui/react-icons'
import { useSuspenseQueries } from '@tanstack/react-query'
import { createFileRoute, getRouteApi } from '@tanstack/react-router'

import { PageLayout } from '@/components/layout/page-layout'
import { Card } from '@/components/ui/card'

import { accountAdminApi } from '@/features/account'
import { outletMasterApi } from '@/features/outlet/outlet-api'

export const Route = createFileRoute('/_app/settings/')({
  component: Component,
})

function Component() {
  const [outlet, account] = useSuspenseQueries({
    queries: [outletMasterApi.list.query({}), accountAdminApi.list.query()],
  })

  const data = [
    ['Outlet', outlet.data.data.outlets.length, getRouteApi('/_app/settings/outlet')],
    ['Pengguna', account.data.data.accounts.length, getRouteApi('/_app/settings/user')],
  ] as const

  return (
    <PageLayout>
      <PageLayout.Header title='Informasi Aplikasi' />
      <div className='grid max-w-xl grid-cols-2 gap-2'>
        {data.map(([title, value, route]) => (
          <Card className='relative p-4' key={title}>
            <div>
              <route.Link>
                <h3 className='flex items-center gap-3 font-semibold underline underline-offset-2'>
                  {title}
                  <OpenInNewWindowIcon />
                </h3>
              </route.Link>
              <p className='mt-1 text-4xl font-bold'>{value}</p>
            </div>
          </Card>
        ))}
      </div>
    </PageLayout>
  )
}
